export enum StoreStatus {
  pending = 'PENDING',
  confirmed = 'CONFIRMED',
  inProgress = 'IN_PROGRESS',
  complete = 'COMPLETE',
  failed = 'FAILED',
}

export enum DecryptionStatus {
  inProgress = 'IN_PROGRESS',
  confirmed = 'CONFIRMED',
  complete = 'COMPLETE',
  failed = 'FAILED',
  rejected = 'REJECTED',
}

export enum ReuseStatus {
  pending = 'PENDING',
  confirmed = 'CONFIRMED',
  notEligible = 'NOT_ELIGIBLE',
  inProgress = 'IN_PROGRESS',
  complete = 'COMPLETE',
  failed = 'FAILED',
  selected = 'SELECTED',
  rejected = 'REJECTED',
}

export type CredentialSubjectDate = {
  day: number;
  month: number;
  year: number;
};

export type IDDocumentCredentialSubject = {
  id: string;
  document: {
    number: string;
    type: string;
    issueCountry: string;
    name: {
      familyNames: string;
      givenNames: string;
    };
    dateOfBirth: CredentialSubjectDate;
    dateOfExpiry: CredentialSubjectDate;
    evidences: {
      idDocumentBack: {
        algorithm: string;
        data: string;
      };
      idDocumentFront: {
        algorithm: string;
        data: string;
      };
      selfie: {
        algorithm: string;
        data: string;
      };
    };
  };
};

export type EmailCredentialSubject = {
  id: string;
  contact: {
    email: {
      domain: {
        name: string;
        tld: string;
      };
      username: string;
    };
  };
};
export type VerifiableCredential<T = Record<string, unknown>> = {
  id: string;
  identifier: string;
  issuer: string;
  issuanceDate: string;
  expirationDate?: string;
  credentialSubject: T;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  proof: any;
};

export type FailedConstraint = {
  credentialId: string;
  identifier: string;
  constraint: {
    path: string;
    // we also support aggregate constraints like $or: [<Constraint>, <Constraint>]
    is: Record<string, unknown> | Record<string, unknown>[];
  };
};

export type VerifiableCredentialExtended<T = Record<string, unknown>> = VerifiableCredential<T> & {
  validation?: {
    isValid: boolean;
    failedConstraints: FailedConstraint[];
  };
};

export type CredentialSchema = Record<string, unknown>;

export type CredentialReuse = {
  status: ReuseStatus | undefined;
  credentialIds: string[];
};
